import { inject } from '@angular/core';
import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ring-builder';

  private swUpdate = inject(SwUpdate);
  private checkForUpdateSubscription?: Subscription

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      console.log('Scheduling update check');
      this.scheduleUpdateCheck();
    } else {
      console.warn('Update check not scheduled');
    }
  }

  private scheduleUpdateCheck() {
    this.checkForUpdateSubscription?.unsubscribe();
    this.checkForUpdateSubscription = interval(30000).subscribe(async () => {
      this.checkForUpdateSubscription?.unsubscribe();
      console.log('Checking for client updates...');
      try {
        const hasUpdate = await this.swUpdate.checkForUpdate();
        if (hasUpdate) {
          console.log('Update found! Prompting user to reload');
          alert('A new version is available. Please reload the page for the changes to take effect.');
          window.location.reload();
        } else {
          console.log('No updates.');
        }
      } catch(e) {
        console.error('Error checking for updates.', e);
      } finally {
        this.scheduleUpdateCheck();
      }
    });
  }
}
